// import React, { useState } from "react";
// import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
// import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
// import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
// import {
//   Menu,
//   MenuItem,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Button,
// } from "@mui/material";
// import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
// import styles from "./chathistory.module.css";
// import ListItem, { ChatItem } from "./LineItem";

// type ChatHistoryProps = {
//   title: string;
//   sectionKey: string;
//   items: ChatItem[];
//   olderItems?: ChatItem[];
//   onSelect?: (id: string) => void;
//   onDelete?: (id: string) => void;
//   onRename?: (id: string, newName: string) => void;
//   activeItemId?: string | null;
//   hasMore?: boolean;
//   onLoadMore?: () => void;
// };

// const ChatHistory = ({
//   title,
//   sectionKey,
//   items,
//   onDelete,
//   onSelect,
//   onRename,
//   activeItemId,
//   hasMore = false,
//   onLoadMore,
// }: ChatHistoryProps) => {
//   const [renameDialogOpen, setRenameDialogOpen] = useState(false);
//   const [newName, setNewName] = useState("");
//   const [renaming, setRenaming] = useState(false);
//   const [openSections, setOpenSections] = useState<Record<string, boolean>>({
//     previous7days: true,
//     previous30days: false,
//     older: false,
//   });
//   const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
//   const [selectedItemId, setSelectedItemId] = useState<string | null>(null);

//   const toggleSection = (section: string) => {
//     setOpenSections((prev) => ({ ...prev, [section]: !prev[section] }));
//   };

//   const handleMoreOptionsClick = (
//     itemId: string,
//     event: React.MouseEvent<Element>
//   ) => {
//     event.stopPropagation();
//     setSelectedItemId(itemId);
//     setAnchorEl(event.currentTarget as HTMLElement);
//   };

//   const handleCloseMenu = () => {
//     setAnchorEl(null);
//     setSelectedItemId(null);
//   };

//   const handleItemClick = (item: ChatItem) => {
//     if (onSelect) {
//       onSelect(item.id);
//     }
//   };

//   const handleMenuItemClick = (action: string) => {
//     switch (action) {
//       case "delete":
//         if (selectedItemId && onDelete) {
//           onDelete(selectedItemId);
//         }
//         handleCloseMenu();
//         break;
//       case "rename":
//         if (selectedItemId) {
//           const selectedItem = items.find((item) => item.id === selectedItemId);
//           setNewName(selectedItem?.title || "");
//           setRenameDialogOpen(true);
//         }
//         // Don't clear selectedItemId yet - we need it for the rename dialog
//         setAnchorEl(null);
//         break;
//     }
//   };

//   const handleRenameSubmit = async () => {
//     if (selectedItemId && newName.trim() && onRename) {
//       setRenaming(true);
//       try {
//         await onRename(selectedItemId, newName.trim());
//         setRenameDialogOpen(false);
//         setNewName("");
//         setSelectedItemId(null);
//       } catch (err) {
//         // Rename error handled by hook
//       } finally {
//         setRenaming(false);
//       }
//     }
//   };

//   const handleRenameCancel = () => {
//     setRenameDialogOpen(false);
//     setNewName("");
//     setSelectedItemId(null);
//   };

//   return (
//     <div className={styles.chatHistory}>
//       {/* Section Header */}
//       <div className={styles.header}>
//         <button
//           onClick={() => toggleSection(sectionKey)}
//           aria-expanded={openSections[sectionKey]}
//         >
//           <h3>{title} </h3>
//           <span className={styles.chevronIcon}>
//             {openSections[sectionKey] ? (
//               <ExpandLessRoundedIcon />
//             ) : (
//               <ExpandMoreRoundedIcon />
//             )}
//           </span>
//         </button>
//       </div>

//       {/* Section Content */}
//       {openSections[sectionKey] && (
//         <div className={styles.content}>
//           {items.length > 0 && (
//             <ul className={styles.listGroup}>
//               {items?.map((item) => (
//                 <li
//                   key={item.id}
//                   className={
//                     activeItemId === item.id ? styles.selectedItem : ""
//                   }
//                 >
//                   <ListItem
//                     item={item}
//                     handleClickMore={handleMoreOptionsClick}
//                     handleClickNavigate={handleItemClick}
//                   />
//                 </li>
//               ))}
//             </ul>
//           )}
//           {items.length === 0 && (
//             <div className={styles.emptyMessage}>
//               No items in {title.toLowerCase()}.
//             </div>
//           )}
//           {hasMore && onLoadMore && (
//             <button
//               className={styles.showMoreButton}
//               onClick={onLoadMore}
//               aria-label="Show more items"
//             >
//               <ExpandMoreRoundedIcon />
//               <span>Show More</span>

//             </button>
//           )}
//         </div>
//       )}

//       {/* Single Menu Instance */}
//       {selectedItemId && (
//         <Menu
//           anchorEl={anchorEl}
//           open={Boolean(anchorEl)}
//           onClose={handleCloseMenu}
//           onClick={(e) => e.stopPropagation()}
//           classes={{
//             root: styles.menuRoot,
//             paper: styles.paperRoot,
//           }}
//         >
//           <MenuItem
//             onClick={() => handleMenuItemClick("rename")}
//             className={styles.menuItem}
//           >
//             <EditOutlinedIcon /> <span>Rename</span>
//           </MenuItem>
//           <MenuItem
//             onClick={() => handleMenuItemClick("delete")}
//             className={styles.deleteMenuItem}
//           >
//             <DeleteOutlineRoundedIcon /> <span>Delete</span>
//           </MenuItem>
//         </Menu>
//       )}

//       {/* Rename Dialog */}
//       <Dialog
//         open={renameDialogOpen}
//         onClose={handleRenameCancel}
//         maxWidth="sm"
//         fullWidth
//         className={styles.renameDialog}
//       >
//         <DialogTitle>Rename Session</DialogTitle>
//         <DialogContent>
//           <TextField
//             autoFocus
//             margin="dense"
//             label="Session Name"
//             type="text"
//             fullWidth
//             variant="outlined"
//             value={newName}
//             onChange={(e) => setNewName(e.target.value)}
//             onKeyDown={(e) => {
//               if (e.key === "Enter" && !renaming) {
//                 handleRenameSubmit();
//               }
//             }}
//             disabled={renaming}
//           />
//         </DialogContent>
//         <DialogActions className={styles.dialogActions}>
//           <Button
//             onClick={handleRenameCancel}
//             disabled={renaming}
//             variant="outlined"
//             color="inherit"
//             size="medium"
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={handleRenameSubmit}
//             variant="contained"
//             disabled={!newName.trim() || renaming}
//             size="medium"
//           >
//             {renaming ? "Renaming..." : "Rename"}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// };

// export default React.memo(ChatHistory);

import React, { useState } from "react";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import {
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import styles from "./chathistory.module.css";
import ListItem, { ChatItem } from "./LineItem";
import LoadingSpinner from "../LoadingSpinner";

type ChatHistoryProps = {
  title: string;
  sectionKey: string;
  items: ChatItem[];
  olderItems?: ChatItem[];
  onSelect?: (id: string) => void;
  onDelete?: (id: string) => void;
  onRename?: (id: string, newName: string) => void;
  activeItemId?: string | null;
  hasMore?: boolean;
  onLoadMore?: () => void;
  loadingMore?: boolean;
  onExpand?: () => void;
  loadingSection?: boolean;
};

const ChatHistory = ({
  title,
  sectionKey,
  items,
  onDelete,
  onSelect,
  onRename,
  activeItemId,
  hasMore = false,
  onLoadMore,
  loadingMore = false,
  onExpand,
  loadingSection = false,
}: ChatHistoryProps) => {
  const [renameDialogOpen, setRenameDialogOpen] = useState(false);
  const [newName, setNewName] = useState("");
  const [renaming, setRenaming] = useState(false);
  const [openSections, setOpenSections] = useState<Record<string, boolean>>({
    previous7days: true,
    previous30days: false,
    older: false,
  });
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedItemId, setSelectedItemId] = useState<string | null>(null);

  const toggleSection = (section: string) => {
    const willExpand = !openSections[section];
    setOpenSections((prev) => ({ ...prev, [section]: !prev[section] }));
    // Trigger onExpand callback when section is being expanded
    if (willExpand && onExpand) {
      onExpand();
    }
  };

  const handleMoreOptionsClick = (
    itemId: string,
    event: React.MouseEvent<Element>
  ) => {
    event.stopPropagation();
    setSelectedItemId(itemId);
    setAnchorEl(event.currentTarget as HTMLElement);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedItemId(null);
  };

  const handleItemClick = (item: ChatItem) => {
    if (onSelect) {
      onSelect(item.id);
    }
  };

  const handleMenuItemClick = (action: string) => {
    switch (action) {
      case "delete":
        if (selectedItemId && onDelete) {
          onDelete(selectedItemId);
        }
        handleCloseMenu();
        break;
      case "rename":
        if (selectedItemId) {
          const selectedItem = items.find((item) => item.id === selectedItemId);
          setNewName(selectedItem?.title || "");
          setRenameDialogOpen(true);
        }
        // Don't clear selectedItemId yet - we need it for the rename dialog
        setAnchorEl(null);
        break;
    }
  };

  const handleRenameSubmit = async () => {
    if (selectedItemId && newName.trim() && onRename) {
      setRenaming(true);
      try {
        await onRename(selectedItemId, newName.trim());
        setRenameDialogOpen(false);
        setNewName("");
        setSelectedItemId(null);
      } catch (err) {
        // Rename error handled by hook
      } finally {
        setRenaming(false);
      }
    }
  };

  const handleRenameCancel = () => {
    setRenameDialogOpen(false);
    setNewName("");
    setSelectedItemId(null);
  };

  return (
    <div className={styles.chatHistory}>
      {/* Section Header */}
      <div className={styles.header}>
        <button
          onClick={() => toggleSection(sectionKey)}
          aria-expanded={openSections[sectionKey]}
        >
          <h3>{title} </h3>
          <span className={styles.chevronIcon}>
            {openSections[sectionKey] ? (
              <ExpandLessRoundedIcon />
            ) : (
              <ExpandMoreRoundedIcon />
            )}
          </span>
        </button>
      </div>

      {/* Section Content */}
      {openSections[sectionKey] && (
        <div className={styles.content}>
          {loadingSection ? (
            <div className={styles.loadingContainer}>
              <LoadingSpinner inline size="sm" label="Loading..." />
            </div>
          ) : (
            <>
              {items.length > 0 && (
                <ul className={styles.listGroup}>
                  {items?.map((item) => (
                    <li
                      key={item.id}
                      className={
                        activeItemId === item.id ? styles.selectedItem : ""
                      }
                    >
                      <ListItem
                        item={item}
                        handleClickMore={handleMoreOptionsClick}
                        handleClickNavigate={handleItemClick}
                      />
                    </li>
                  ))}
                </ul>
              )}
              {items.length === 0 && (
                <div className={styles.emptyMessage}>
                  No items in {title.toLowerCase()}.
                </div>
              )}
              {hasMore && onLoadMore && (
                <button
                  className={styles.showMoreButton}
                  onClick={onLoadMore}
                  aria-label="Show more items"
                  disabled={loadingMore}
                >
                  {loadingMore ? (
                    <LoadingSpinner inline size="xs" label="Loading..." />
                  ) : (
                    <>
                      <ExpandMoreRoundedIcon />
                      <span>Show More</span>
                    </>
                  )}
                </button>
              )}
            </>
          )}
        </div>
      )}

      {/* Single Menu Instance */}
      {selectedItemId && (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleCloseMenu}
          onClick={(e) => e.stopPropagation()}
          classes={{
            root: styles.menuRoot,
            paper: styles.paperRoot,
          }}
        >
          <MenuItem
            onClick={() => handleMenuItemClick("rename")}
            className={styles.menuItem}
          >
            <EditOutlinedIcon /> <span>Rename</span>
          </MenuItem>
          <MenuItem
            onClick={() => handleMenuItemClick("delete")}
            className={styles.deleteMenuItem}
          >
            <DeleteOutlineRoundedIcon /> <span>Delete</span>
          </MenuItem>
        </Menu>
      )}

      {/* Rename Dialog */}
      <Dialog
        open={renameDialogOpen}
        onClose={handleRenameCancel}
        maxWidth="sm"
        fullWidth
        className={styles.renameDialog}
      >
        <DialogTitle>Rename Session</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Session Name"
            type="text"
            fullWidth
            variant="outlined"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !renaming) {
                handleRenameSubmit();
              }
            }}
            disabled={renaming}
          />
        </DialogContent>
        <DialogActions className={styles.dialogActions}>
          <Button
            onClick={handleRenameCancel}
            disabled={renaming}
            variant="outlined"
            color="inherit"
            size="medium"
          >
            Cancel
          </Button>
          <Button
            onClick={handleRenameSubmit}
            variant="contained"
            disabled={!newName.trim() || renaming}
            size="medium"
          >
            {renaming ? "Renaming..." : "Rename"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default React.memo(ChatHistory);

